const SitePrivacyPolicyContent = {
    purpose: {
        title: "個人情報の利用目的",
        body: "当サイトでは、お問い合わせやコメントの際、名前やメールアドレス等の個人情報を入力いただく場合がございます。取得した個人情報は、お問い合わせに対する回答や必要な情報を電子メールなどをでご連絡する場合に利用させていただくものであり、これらの目的以外では利用いたしません。",
    },
    disclosure: {
        title: "個人情報の第三者への開示",
        body: "当サイトでは、個人情報は適切に管理し、以下に該当する場合を除いて第三者に開示することはありません。",
        items: [
            '本人のご了解がある場合',
            '法令等への協力のため、開示が必要となる場合',
        ],
        additionalNote:
            'ご本人からの個人データの開示、訂正、追加、削除、利用停止のご希望がある場合は、ご本人であることを確認させていただいた上で、速やかに対応させていただきます。',
    },
    cookie: {
        title: "Cookie",
        body: "Cookie（クッキー）は、利用者のサイト閲覧履歴を、利用者のコンピュータに保存しておく仕組みです。利用者はCookie（クッキー）を無効にすることで収集を拒否することができますので、お使いのブラウザの設定をご確認ください。ただし、Cookie（クッキー）を拒否した場合、当サイトのいくつかのサービス・機能が正しく動作しない場合があります。",
    },
    advertising: {
        title: "広告について",
        body: "当サイトでは、第三者配信の広告サービス（Googleアドセンス）を利用しており、ユーザーの興味に応じた商品やサービスの広告を表示するため、クッキー（Cookie）を使用しております。クッキーを使用することで当サイトはお客様のコンピュータを識別できるようになりますが、お客様個人を特定できるものではありません。Cookieを無効にする方法やGoogleアドセンスに関する詳細は",
        additionalNote: "をご確認ください。また、当サイトの運営者は、Amazonアソシエイト・プログラムの参加者です。"
    },
    analyticsTool: {
        title: "アクセス解析ツールについて",
        body: "当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。このGoogleアナリティクスはトラフィックデータの収集のためにクッキー（Cookie）を使用しております。トラフィックデータは匿名で収集されており、個人を特定するものではありません。この機能は、Cookieを無効にすることで収集を拒否することが出来ます。",
    },
    copyright: {
        title: "著作権・肖像権",
        body: "当サイトで掲載しているすべてのコンテンツ（文章、画像、動画、音声、ファイル等）の著作権・肖像権等は当サイト所有者または各権利所有者が保有し、許可なく無断利用（転載、複製、譲渡、二次利用等）することを禁止します。また、コンテンツの内容を変形・変更・加筆修正することも一切認めておりません。各権利所有者におかれましては、万一掲載内容に問題がございましたら、ご本人様よりお問い合わせください。迅速に対応いたします。",
    },
    privacyPolicyChanges: {
        title: "本プライバシーポリシーの変更",
        body: "本ポリシーの内容は，法令その他本ポリシーに別段の定めのある事項を除いて，ユーザーに通知することなく，変更することができるものとします。変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。",
    },
    disclaimer: {
        title: "免責事項",
        body: "また当サイトのコンテンツ・情報について、可能な限り正確な情報を掲載するよう努めておりますが、正確性や安全性を保証するものではありません。当サイトに掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。当サイトからリンクやバナーなどによって他のサイトに移動した場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。当サイトで掲載している料金表記について、予告なく変更されることがあります。",
    }

};

export default SitePrivacyPolicyContent;